module.exports = __webpack_public_path__ + "static/media/footer-ico4.e79b7945.svg";